import { SvgIcon } from "@material-ui/core";
import React from "react";

const EffectIcon = props => (
  <SvgIcon>
    <g id="Icon/EffectIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="24"
        fill="none"
        viewBox={props.viewBox}
      >
        <g clipPath="url(#EffectIcon)">
          <path
            stroke={props.color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.6"
            d="M18.622 10.335c-.57 3.48-2.872 5.392-2.872 5.392l1.5 7.523H9l-.75-1.5-3.383-.555a1.496 1.496 0 01-1.244-1.297L3 15l-2.25-.75 1.5-4.357M2.25 9.893l.007-1.238C2.257 4.23 6.045.75 11.206.75"
          />
          <path
            fill={props.color}
            d="M16.455 4.522L19.5.022h-4.402l-2.393 6h2.25l-1.5 5.25 5.25-6.75h-2.25z"
          />
        </g>
        <defs>
          <clipPath id="EffectIcon">
            <path fill="#fff" d="M0 0H19.5V24H0z"/>
          </clipPath>
        </defs>
      </svg>
    </g>
  </SvgIcon>
);

export default EffectIcon;



// WEBPACK FOOTER //
// ./src/icons/EffectIcon.jsx